export default "__VITE_ASSET__BXvNTE79__"